module.exports = __webpack_public_path__ + "static/media/Poppins-Light.b2b23d25.ttf";